import * as types from '../../action-types';
import {getMyISOStipulation as initialState } from "../../initialState";

const getMyISOStipulation = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_MY_ISO_STIPULATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_MY_ISO_STIPULATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_MY_ISO_STIPULATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_MY_ISO_STIPULATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getMyISOStipulation;


